// extracted by mini-css-extract-plugin
export default {"container":"GPagination-module_container_f69fce88"};